import { SelectInputModel, SubmitGroupItemModel, TextInputModel } from '@libs/form/models';

export const SalutationInputData: SelectInputModel = {
  type: 'select',
  name: 'salutation',
  label: 'Anrede',
  hint: '*Pflichtfeld',
  attributes: {
    required: true,
  },
  options: [
    { label: 'Frau', value: 'MS' },
    { label: 'Herr', value: 'MR' },
  ],
};

export const FirstNameInputData: TextInputModel = {
  type: 'text',
  name: 'givenName',
  label: 'Vorname',
  hint: '*Pflichtfeld',
  attributes: {
    autocomplete: 'given-name',
    required: true,
    spellcheck: false,
  },
};

export const LastNameInputData: TextInputModel = {
  type: 'text',
  name: 'lastName',
  label: 'Nachname',
  hint: '*Pflichtfeld',
  attributes: {
    autocomplete: 'family-name',
    required: true,
    spellcheck: false,
  },
};

export const SubmitGroupData: SubmitGroupItemModel = {
  type: 'submit',
  items: [
    {
      name: 'save',
      label: 'Speichern',
    },
  ],
};
